/**
 * Schema of TipoOcorrencia
 * @author Simpli CLI generator
 */
import {datetime, InputType, Schema, time} from 'simpli-web-sdk'
import {bool} from 'simpli-web-sdk'
import JornadaMotorista from '@/model/resource/JornadaMotorista'
import moment from 'moment'

export default (model: JornadaMotorista): Schema => ({
    idMotoristaJornadaPk: {
        content: model.idMotoristaJornadaPk,
        editable: false,
    },

    horaInicio: {
        content: model.horaInicio.toString(),
        textContent: null,
        input: InputType.MASK,
        meta: {
            required: true,
            maxlength: '5',
            mask: 'FI:DO',
            masked: true,
            placeholder: 'hh:mm',
            tokens: {
                F: {pattern: /[0-2]/},
                I: {pattern: /[0-9]/},
                D: {pattern: /[0-5]/},
                O: {pattern: /[0-9]/},
            },
        },
    },

   horaFim: {
       content: model.horaFim.toString(),
       textContent: null,
       input: InputType.MASK,
       meta: {
           required: true,
           maxlength: '5',
           mask: 'FI:DO',
           masked: true,
           placeholder: 'hh:mm',
           tokens: {
               F: {pattern: /[0-2]/},
               I: {pattern: /[0-9]/},
               D: {pattern: /[0-5]/},
               O: {pattern: /[0-9]/},
           },
       },
    },

    rangeCepInicial: {
        content: model.rangeCepInicial,
        textContent: null,
        input: InputType.CEP,
        meta: {
            required: true,
            maxlength: '10',
        },
    },

    rangeCepFinal: {
        content: model.rangeCepFinal,
        textContent: null,
        input: InputType.CEP,
        meta: {
            required: true,
            maxlength: '10',
        },
    },

    ativo: {
        content: bool(model.ativo),
        input: InputType.CHECKBOX,
    },

    segunda: {
        content: bool(model.segunda),
        input: InputType.CHECKBOX,
    },
    terca: {
        content: bool(model.terca),
        input: InputType.CHECKBOX,
    },
    quarta: {
        content: bool(model.quarta),
        input: InputType.CHECKBOX,
    },
    quinta: {
        content: bool(model.quinta),
        input: InputType.CHECKBOX,
    },
    sexta: {
        content: bool(model.sexta),
        input: InputType.CHECKBOX,
    },
    sabado: {
        content: bool(model.sabado),
        input: InputType.CHECKBOX,
    },
    domingo: {
        content: bool(model.domingo),
        input: InputType.CHECKBOX,
    },
})
